exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cardWrapper {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.printButton {\n  background-color: #1d88f61a !important;\n  color: #1d88f6 !important;\n}\n\n.buttonIcon {\n  margin-right: 8px;\n}\n", ""]);

// exports
